export const ADD_PAYMENT_SUCCESS = 'ADD_PAYMENT_SUCCESS';
export const INVOICE_PAID_TRUE = 'INVOICE_PAID_TRUE';
export const INVOICE_PAID_FALSE = 'INVOICE_PAID_FALSE';
export const CLEAR_SESSION = 'CLEAR_SESSION';
export const CLEAN_REDUCER = 'CLEAN_REDUCER';
export const GET_DEPOSITORS = 'GET_DEPOSITORS';
